<template>
  <div>
    <main>
      <div class="row">
        <div id="playercolumn" class="col s12 m6 l5 offset-l1" :class="{processing: processing}" style="min-height:200px">
          <div id="player" v-if="!error" ></div>
          <div class="uploader-processing" v-if="processing">
            <div>Hang tight. We're preparing your video for primetime.</div>
            <div class="progress">
              <div class="indeterminate"></div>
            </div>
          </div>
          <div id="player-error" v-if="error || loading"></div>

          <div class="tutorial-info card">
            <ul class="collapsible" v-on:click="resizeHandler">
              <li>
                <div class="tutorial-header collapsible-header">
                  <div class="tutorial-info">
                    <div class="tutorial-title">{{title || '--'}}</div>
                    <ul class="tutorial-data desktop">
                      <li>
                        <i class="material-icons">videocam</i>
                        {{duration}}
                      </li>
                      <li>
                        <i class="material-icons">timer</i>
                        {{time_to_complete || '-- minutes'}}
                      </li>
                    </ul>
                  </div>
                  <div class="toggle">
                    <i class="material-icons expand-icon">keyboard_arrow_down</i>
                  </div>
                </div>
                <div class="collapsible-body">
                  <div class="description">
                    {{description}}
                    <ul class="tutorial-data mobile">
                      <li>
                        <i class="material-icons">videocam</i>
                        {{duration}}
                      </li>
                      <li>
                        <i class="material-icons">timer</i>
                        {{time_to_complete || '-- minutes'}}
                      </li>
                    </ul>
                  </div>
                  <div class="footerf">
                    <a href="http://fyi.io/" target="_blank">
                      <img src="../assets/logo.png" />
                      <span style="color:#58595B">&nbsp;&nbsp;powered by fyiio</span>
                    </a>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col s12 m6 l5 steps-wrap" style="min-height:200px">
          <Steps
            :steps="steps"
            :current_step="current_step"
            :step_click="selectStep"
            :editing="false"
            v-if="!error && steps.length > 0"
          />
          <div class="error-step card" v-if="error">
            <div class="error-step-title">Sorry, this tutorial is not available.</div>
            <div class="error-step-desc">
              <p>
                Here are some
                <a
                  href="https://imgur.com/search/score?q=corgi+puppy"
                  target="_blank"
                >corgi pictures</a> to make it all better.
              </p>

              <p>Is this your tutorial? One of a couple things could have happened:</p>
              <ol>
                <li>You deleted this tutorial.</li>
                <li>The embed code/link was copied incorrectly.</li>
                <li>Your trial has ended and/or need to update payment information.</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    <!-- Modal Structure -->
    <div id="modal1" class="modal modal-fixed-footer">
      <div class="modal-content">
        
        <img :src="protectionLogo" height="15%" v-if="protectionLogo"><hr>
        <br><br><h3 class="center">Protected Content</h3>
        <br><br><h5>{{protectionMessage}}</h5>
      </div>
      <div class="modal-footer ">
        If you believe you have received this message in error, please contact your system administrator.
      </div>
    </div>

    </main>
  </div>
</template>

<script>
import GqlQuery from "@/plugins/gql";
import GqlV2Query from "@/plugins/gqlV2"
import Steps from "@/components/Steps";
import cognitoAuth from "@/plugins/cognito";

let [lang, locale] = (navigator.userLanguage || navigator.language)
  .replace("-", "_")
  .toLowerCase()
  .split("_");

let defaultAnalyticsData = {
  timeActiveOnTutorial: 0,
  timeWatchedOnTutorial: 0,
  timeActiveOnStep: 0,
  timeWatchedOnStep: 0,
  isPlaying: false,
  isActive: true
};
export default {
  props: ["processing", "setProcessing"],
  data() {
    return {
      id: this.$route.params.id,
      preview: this.$route.name == "Preview",
      title: "--",
      description: "loading description",
      tutorial: false,
      time_to_complete: "-- minutes",
      steps: [],
      protectionMessage:'',
      protectionLogo:undefined,
      error_steps: [
        {
          title: "error title",
          description: "error desc"
        }
      ],
      organization_id: undefined, 
      current_step: 0,
      video_url: false,
      duration: "-:--",
      analyticsData: Object.assign({}, defaultAnalyticsData),
      organization: false,
      loading: true,
      error: false,
      user: false,
      preventedAutoplay: false
    };
  },

  mounted() {
    var self = this;

    cognitoAuth.isAuthenticated((err, loggedIn) => {
      if (loggedIn) {
        cognitoAuth.getUserAttributes(function(err, user_attributes) {
          self.user = user_attributes;
          self.loadTutorial();
        });
      } else {
        self.loadTutorial();
      }
    });
  },
  watch: {   
  },
  methods: {
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    protectContent(){
      const elem = document.getElementById('modal1');
      const instance = M.Modal.init(elem, {dismissible: false});
      instance.open();
    },
    checkContentAgainstOrganizationAccessPolicy(tutorial){
      
      let self = this;
      self.organization_id=tutorial.organization.id
      if(!self.preview){
        GqlV2Query.getOrganizationAccessPolicy(self.organization_id, (err, result) => {
              if (err) {
                this.error = err;
              } else {
                console.log("Back, baby, result:=>", result.data)
                let hold=result.data;
                let hold_org=undefined
                if(hold && hold.organization){
                  hold_org=hold.organization;
                 }
                let access_policy=undefined;
                if(hold_org && hold_org.length>0){
                  access_policy=hold_org[0].protected_content_policy
                  console.log(access_policy)
                  if(access_policy.api_type=='graphql'){
                    let endpoint=access_policy.token_validation_remote_endpoint;
                    console.log("endpoint is:", endpoint)
                    let graphqlquery=access_policy.token_query;
                    
                    console.log("graphql query is ", graphqlquery)
                    let logo=access_policy.logo_url;
                    if(logo && logo !=''){
                      self.protectionLogo=logo;
                    }
                    let query_param=access_policy.query_parameter_name;
                    console.log("QueryParam:", query_param)
                    console.log(this.$route.query)
                    let queryval=this.$route.query[query_param]
                    if(!queryval){
                      self.protectionMessage="This content requires a valid access token, and no token was present. Please check the source and try again."
                      self.protectContent()
                      return
                    }
                    console.log(`self.$route.query.${query_param}`)
                    let query=access_policy.token_query;
                    console.log("query:", query)
                    let header_structure=access_policy.header_structure;
                    header_structure=JSON.stringify(header_structure).replace("${token}", queryval)
                    console.log("Graphql baby!", query, header_structure)
                    GqlV2Query.authorizedContentCheck(endpoint, header_structure, query, function(err, response){
                      if(err){
                        self.protectionMessage="This content requires a valid access token. The token provided was either invalid or has expired. Please check the source and try again."
                        self.protectContent()
                        console.log("status:", err.status)
                        console.log("error:", err.error);
                      }else{
                        console.log("response:", response)
                        if(response.data){
                          console.log("return from authcontent:", response.data)
                        }
                        if(response.data && response.data.session){
                          console.log("Valid session");
                          self.setupTutorial(tutorial)
                        }else{
                          self.protectionMessage="An error occurred verifying your access token. Please try again and if the error persists, please contact your administrator."
                          self.protectContent()
                        }
                      }
                    })
                  }
                }else{
                  console.log("No protected content policy for this organization. Proceed")
                  self.setupTutorial(tutorial);
                }
                
              }
          }
        );
      }else{
        self.setupTutorial(tutorial);
      }
    },
    setupTutorial(tutorial){
      let self=this;
      //if (val && val.data && val.data.chapter) {
      if(tutorial) {
        self.organization_id=tutorial.organization.id;
        console.log("org id:", self.organization_id);

        if (tutorial.video_duration) {
          var date = new Date(null);
          date.setSeconds(tutorial.video_duration);
          self.duration = date
            .toISOString()
            .substr(14, 5)
            .replace(/^0/, "");
        }
        self.tutorial = tutorial;

        if (!self.tutorial.published) {
          if (!self.user) {
            return (self.error = true);
          } else if (
            self.user["custom:organization_id"] != tutorial.organization.id
          ) {
            console.log("no org error");
            return (self.error = true);
          }
        }
        self.setUpPlayer();

        self.time_to_complete = tutorial.time_to_complete;
        if (self.preview && tutorial.draft) {
          let draft = JSON.parse(tutorial.draft);
          tutorial = Object.assign(
            {},
            tutorial,
            JSON.parse(tutorial.draft)
          );
          self.time_to_complete = draft.time_to_complete;
        }

        self.title = tutorial.title.replace(/_/g, " ");
        let window_title = "";
        if (
          tutorial &&
          tutorial.organization &&
          tutorial.organization.name
        ) {
          window_title += tutorial.organization.name + " | ";
        }
        window_title += tutorial.title.replace(/_/g, " ");
        document.title = window_title;

        self.description = tutorial.description;
        self.steps = tutorial.steps;
        self.video_url = tutorial.video_url;
        if (tutorial.video_upload) {
          var video_upload = JSON.parse(tutorial.video_upload);
          self.raw_url = video_upload.raw_url;
          self.video_url = video_upload.video_url;
        }
        self.organization = tutorial.organization;
        jwplayer().load([
          {
            file: self.video_url
          }
        ]);

        $(document).ready(function() {
          setTimeout(function() {
            $(".jw-display-icon-rewind").remove();
            $(".jw-icon-playback-rate").remove();
          }, 500);
          $(".jw-display-icon-rewind").remove();
          $(".jw-icon-playback-rate").remove();
        });

        self.loading = false;
        self.sendCustomEvent({
          category: "tutorial",
          action: "start",
          fieldsObject: {
            dimension1: self.organization.id,
            dimension2: self.steps[self.current_step].id
          }
        });
        self.setUpAnalyticsHandlers();
        setTimeout(function() {
          var elems = document.querySelectorAll(
            ".tutorial-info .collapsible"
          );
          var instances = M.Collapsible.init(elems);
          self.resizeHandler();
        }, 300);
      } else {
        // no tutorial
        console.log("no tutorial error");
        self.error = true;
      }

    },
    loadTutorial() {
      var self = this;
      if (lang == "en") {
        console.log("retrieving default language");
      } else {
        console.log("retrieving tutorial for " + lang);
      }

      GqlQuery.getTutorial(this.id, lang, function(err, response) {
        if (err) {
          console.log("getTutorial error: ", err);
          self.error = err;
          self.loading = false;
          $("#player").hide();

          return;
        }
        response.json().then(function(val) {
          var tutorial = val.data.chapter;
          self.checkContentAgainstOrganizationAccessPolicy(tutorial)
        });
      });
    },

    setUpPlayer() {
      var self = this;
      jwplayer("player").setup({
        file: "/assets/120.mp4",
        playbackRateControls: [0.75, 1, 1.25, 1.5],
        mute: false,
        tracks: [],
        displaytitle: false,
        width: "100%",
        aspectratio: "16:9"
      });

      let errorcount = 0;
      jwplayer().on("error", function(err) {
        // occassionally the CDN will not have the full video, in which case ther will be an error loading,
        // we'll try the video_url a few times, then will default to raw_url, which goes to S3
        self.setProcessing(true);
        setTimeout(function() {
          errorcount++;

          if (errorcount > 60) {
            self.processing = false;
            self.error = true;

            return;
          } else {
            jwplayer().load([
              {
                file: self.video_url
              }
            ]);
            console.log("error, but didn't upload");
          }

          console.log("jwplayer error is ", err);
        }, 3000 * errorcount);
      });

      jwplayer().on("time", function(e) {
        if (e && e.duration > 0 && self.duration == "-:--") {
          // if (self.processing) {self.processing = false}
          if (self.setProcessing) {
            self.setProcessing(false);
          }
          var date = new Date(null);
          date.setSeconds(e.duration);

          self.duration = date
            .toISOString()
            .substr(14, 5)
            .replace(/^0/, "");
        }

        if (
          self.inIframe() &&
          !self.preventedAutoplay &&
          self.duration !== "-:--"
        ) {
          self.preventedAutoplay = true;
          jwplayer().pause();
        }

        self.checkTime(e);
      });
    },

    unloadHander() {
      self.reportTimeOnStep();
      self.reportTimeOnTutorial();
      return undefined;
    },

    setUpAnalyticsHandlers() {
      var self = this;

      $(document).ready(function() {
        $(document).idleTimer(5000);
        $(document).on("idle.idleTimer", function(event, elem, obj) {
          self.analyticsData.isActive = false;
        });
        $(document).on("active.idleTimer", function(
          event,
          elem,
          obj,
          triggerevent
        ) {
          self.analyticsData.isActive = true;
        });
      });

      setInterval(function() {
        self.updateAnalyticsTimer();
      }, 1000);

      jwplayer().on("play", function() {
        self.analyticsData.isPlaying = true;
        self.sendCustomEvent({
          category: "step",
          action: "play"
        });
      });

      jwplayer().on("pause", function() {
        self.analyticsData.isPlaying = false;
        self.sendCustomEvent({
          category: "tutorial",
          action: "pause"
        });
      });

      jwplayer().on("seek", function() {
        // reports seek event's step as one it's seeking from, not to
        self.analyticsData.isPlaying = true;
        self.sendCustomEvent({
          category: "step",
          action: "seek"
        });
      });

      jwplayer().on("complete", function() {
        self.analyticsData.isPlaying = true;
        self.sendCustomEvent({
          category: "tutorial",
          action: "complete"
        });
        self.reportCompletedStep(self.current_step);
        self.reportTimeOnStep();
        self.reportTimeOnTutorial();
      });
    },

    reportCompletedStep(old_chapter_i) {
      var self = this;
      old_chapter_i = old_chapter_i || self.current_step;
      if (self.steps && self.steps[old_chapter_i]) {
        var step_id = self.steps[old_chapter_i].id;
      }
      self.sendCustomEvent({
        category: "step",
        action: "complete",
        fieldsObject: {
          dimension3: step_id,
          dimension4: old_chapter_i
        }
      });
    },

    reportTimeOnStep(old_chapter_i) {
      var self = this;
      var reporting_chapter_id = old_chapter_i || self.current_step;
      var step_id = 0;
      if (
        self.steps &&
        self.steps[reporting_chapter_id] &&
        self.steps[reporting_chapter_id].id
      ) {
        step_id = self.steps[reporting_chapter_id].id;
      }

      self.sendCustomEvent({
        category: "step",
        action: "time-watched",
        value: self.analyticsData.timeWatchedOnStep,
        fieldsObject: {
          dimension3: step_id,
          dimension4: reporting_chapter_id
        }
      });

      self.sendCustomEvent({
        category: "step",
        action: "time-active",
        value: self.analyticsData.timeActiveOnStep,
        fieldsObject: {
          dimension3: step_id,
          dimension4: reporting_chapter_id
        }
      });

      self.analyticsData.timeActiveOnStep = 0;
      self.analyticsData.timeWatchedOnStep = 0;
    },

    reportTimeOnTutorial() {
      var self = this;
      self.sendCustomEvent({
        category: "tutorial",
        action: "time-watched",
        value: self.analyticsData.timeWatchedOnTutorial
      });

      self.sendCustomEvent({
        category: "tutorial",
        action: "time-active",
        value: self.analyticsData.timeActiveOnTutorial
      });

      self.analyticsData.timeActiveOnTutorial = 0;
      self.analyticsData.timeWatchedOnTutorial = 0;
    },

    updateAnalyticsTimer() {
      if (this.analyticsData.isActive || this.analyticsData.isPlaying) {
        this.analyticsData.timeActiveOnTutorial += 1;
        this.analyticsData.timeActiveOnStep += 1;
      }
      if (this.analyticsData.isPlaying) {
        this.analyticsData.timeWatchedOnTutorial += 1;
        this.analyticsData.timeWatchedOnStep += 1;
      }
    },

    sendCustomEvent(options) {
      // dimension1: organization id
      // dimension2: tutorial id
      // dimension3: step id
      // dimension4: step index
      // dimention5: organization name
      // dimension6: tutorial name

      var self = this;
      if (
        options.fieldsObject &&
        options.action == "start" &&
        options.fieldsObject.dimension1 == undefined
      ) {
        return;
      } else if (
        (options.action == "time-watched" || options.action == "time-active") &&
        options.value < 2
      ) {
        return;
      } else {
        options.fieldsObject = options.fieldsObject || {};
        if (!options.fieldsObject.dimension1) {
          options.fieldsObject.dimension1 = self.organization.id;
        }
        if (!options.fieldsObject.dimension2) {
          options.fieldsObject.dimension2 = self.id;
        }
        var step_id = -1;
        if (self.current_step && self.steps && self.steps[self.current_step]) {
          step_id = self.steps[self.current_step].id;
        }
        if (!options.fieldsObject.dimension3) {
          options.fieldsObject.dimension3 = step_id;
        }
        if (!options.fieldsObject.dimension4 || step_id == -1) {
          options.fieldsObject.dimension4 = self.current_step;
        }
        if (!options.fieldsObject.dimension5) {
          options.fieldsObject.dimension5 = self.organization.name;
        }
        if (!options.fieldsObject.dimension6) {
          options.fieldsObject.dimension6 = self.title;
        }

        ga(
          "send",
          "event",
          options.category,
          options.action,
          options.label,
          options.value,
          options.fieldsObject
        );
      }
    },

    resizeHandler() {
      if (!document.getElementById("playercolumn")) return;

      let height = document.getElementById("playercolumn").offsetHeight;

      if (document.body.offsetWidth < 601) {
        height = document.body.offsetHeight - height;
        document.getElementById(
          "steps-gradient-scroller"
        ).style.height = `${height}px`;
      } else {
        document.getElementById(
          "steps-gradient-scroller"
        ).style.height = `${height}px`;
        setTimeout(function() {
          let height = document.getElementById("playercolumn").offsetHeight;
          document.getElementById(
            "steps-gradient-scroller"
          ).style.height = `${height}px`;
        }, 350);
      }
    },

    selectStep(step_index) {
      var self = this;
      self.selectingStep = true
      this.current_step = step_index;
      var start_time = this.steps[step_index].start_time;
      jwplayer().seek(parseInt(start_time));

      setTimeout(function() {
        self.scrollToStep(step_index);
      }, 625);
    },

    scrollToStep(step_index) {
      let self = this

      var elem = $(".steps.collapsible")[0];
      var instance = M.Collapsible.getInstance(elem);
    
      let wrapPadding = 55 * (step_index + 1) + 58;
      document.getElementById("scrollToContainer").style.paddingBottom =
        wrapPadding + "px";
      setTimeout(function() {
        self.selectingStep = false
        let scrollTo = $("#step_" + step_index)[0].offsetTop;

        $("#steps-gradient-scroller").animate(
          {
            scrollTop: scrollTo
          },
          300
        );
      }, 350);
    },

    checkTime(e) {
      var self = this;

      var active_step = this.steps[this.current_step];
      // this.selectStep(this.current_step)
      if (!active_step) return;
      if (self.selectingStep) return;
      if (
        !(
          parseInt(active_step.start_time) < e.position &&
          parseInt(active_step.end_time) > e.position
        )
      ) {
        this.steps.forEach((step, index) => {
          if (
            parseInt(step.start_time) < e.position &&
            parseInt(step.end_time) > e.position
          ) {
            self.current_step = index;
            // self.selectStep(index);
            var instance = M.Collapsible.getInstance(
              $(".collapsible.steps")[0]
            );
            instance.open(index);
            setTimeout(function() {
              self.scrollToStep(index);
            }, 625);
            self.reportTimeOnStep(index - 1);
            if (self.steps && self.steps[index - 1]) {
              self.reportCompletedStep(index - 1);
            }
            self.sendCustomEvent({ category: "step", action: "start" });
          }
        });
      }
    }
  },
  components: {
    Steps
  }
};
</script>
<style scoped>
.jw-icon-rewind {
  display: none !important;
}
.tutorial-header:focus {
  outline: none !important;
}
pre {
  white-space: pre-wrap; /* Since CSS 2.1 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
#playercolumn {
  max-width: 840px;
}
.error-step {
  border-left: 50px solid #58595b;
  text-align: left;
  width: 98%;
  margin-top: 3px;
}
.error-step-title {
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  padding: 12px;
}
.error-step-desc {
  padding: 12px;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 14px;
  line-height: 20px;
}
.error-step-desc {
  border-top: 1px solid #939598;
  padding: 12px;
}
.error-step-desc p:first-of-type {
  margin-top: 0px !important;
}
.error-step-desc p:last-of-type {
  margin-bottom: 0px !important;
}
.processing #player {
  display: none;
}
.progress {
  background-color: #7ac7e7;
}
.progress .determinate,
.progress .indeterminate {
  background-color: #29abe1;
}
.uploader-processing .progress {
  width: 210px;
}
.uploader-progress,
.uploader-processing {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 309px;
  justify-content: center;
  align-items: center;
  text-align: center;
  max-width: 510px;
  text-align: center;
  margin: 0 auto;
  margin-bottom: 21px;
}

.jw-state-error,
#player.jw-icon-playback-rate #player.jw-display-icon-rewind,
#player .jw-display-icon-rewind {
  display: none !important;
}
.jw-display-icon-container.jw-display-icon-rewind.jw-background-color.jw-reset {
  display: none !important;
}
.collapsible-header:focus {
  outline: none !important;
}
</style>
<style scoped>
.card {
  box-shadow: none;
}
.tutorial-info .collapsible {
  box-shadow: none;
  border: 2px solid #f1f1f1;
}
main {
  padding-top: 50px;
}

#player-error {
  background-color: #939598;
  width: 100%;
  padding-top: 50%;
}
i.expand-icon {
  margin-right: 0;
}
.tutorial-header {
  color: rgba(0, 0, 0, 0.87);
  line-height: 32px;
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-color: #ddd !important;
  border-bottom: none;
}

.tutorial-header .tutorial-info {
}

.tutorial-data {
  margin-top: 12px;
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
}
.tutorial-data li {
  display: inline-flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.87);
  border-left: 1px solid #58595b;
  padding-left: 12px;
  padding-right: 12px;
  text-transform: lowercase;
}
.tutorial-data li:first-of-type {
  border-left: none;
  padding-left: 0px;
}
.tutorial-header i {
  margin-right: 10px;
}
.tutorial-data i {
  color: #58595b;
}
.expand-icon {
  color: #58595b;
  float: right;
  transition: transform 300ms;
}
.active .expand-icon {
  transform: rotate(180deg);
}
.mobile-title {
  color: #58595b;
  font-family: Roboto;
  font-size: 27px;
  font-weight: 200;
  text-align: center;
}

main {
  margin-bottom: 50px;
}

.hidden {
  display: none;
}

.description {
  font-family: Roboto;
  font-size: 14px;
  text-align: left !important;
  font-weight: 400 !important;
}
.time-to-complete {
  height: 105px;
  border-style: solid !important;
  border-radius: 16px;
}

.tutorial-time-to-complete-label {
  font-weight: 400;
  color: #58595b;
  text-align: center;
  width: 100%;
  margin-top: 15px;
  margin-bottom: 5px;
}
.tutorial-time-to-complete {
  font-weight: 600;
  line-height: 1;
  letter-spacing: 10px;
  color: #27aae1;
}

.footerf {
  background-color: #f1f1f1 !important;
  border-color: black;
  border-width: 0px;
  vertical-align: center;
  text-align: center;
  z-index: 1000;
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  padding: 1px;
}
.footerf img {
  vertical-align: middle;
  height: 10px;
  padding-right: 12px;
}
.tutorial-info .collapsible-body {
  padding: 0;
  border-bottom: none;
}
.tutorial-info .description {
  padding: 12px;
}

@media only screen and (max-width: 850px) {
  .tutorial-data li {
    padding-left: 0;
    border: none;
  }
}

@media only screen and (min-width: 601px) {
  #playercolumn {
    /* padding-left: 50px; */
    padding-right: 33px;
  }

  .tutorial-data.desktop {
    display: block;
  }
  .tutorial-data.mobile {
    display: none;
  }
  #title-container,
  #description-container,
  .time-to-complete {
    display: block;
  }
  .mobile-title,
  .mobile-time {
    display: none;
  }
}
@media only screen and (max-width: 601px) {
  main {
    padding-top: 0;
  }
  #playercolumn {
    padding: 0;
  }
  .tutorial-info,
  .tutorial-info .collapsible {
    box-shadow: none;
    border: none;
  }
  .tutorial-info ul {
    margin: 0;
  }

  .tutorial-data {
    padding-bottom: 12px;
    padding-top: 12px;
  }
  .steps-wrap {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }
  .active {
    margin-bottom: 12px;
  }
  .tutorial-data li {
    display: inline-flex;
    align-items: center;
    color: rgba(0, 0, 0, 0.87);
    border-left: 1px solid #dfdfdf;
    padding-left: 25px;
    padding-right: 25px;
    text-transform: lowercase;
    border: none !important;
    font-size: 12px;
    font-weight: normal;
  }
  .tutorial-data li i {
    margin-right: 1rem;
  }
  .tutorial-header .tutorial-info {
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 14px;
    line-height: 20px;
  }
  .tutorial-description,
  .description {
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 12px;
    line-height: 20px;
  }
  .tutorial-date {
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    padding-bottom: 12px;
  }

  .tutorial-data.desktop {
    display: none;
  }
  #title-container,
  #description-container,
  .time-to-complete {
    display: none;
  }
  .mobile-title,
  .mobile-time {
    display: block;
  }
  .footerf {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
  }
  .tutorial-title {
    color: rgba(0, 0, 0, 0.87);
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  .tutorial-info {
    margin-top: 0;
  }

  .tutorial-header {
    padding-top: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.87);
  }
}
.mobile-time {
  width: 100%;
  text-align: center;
  font-weight: 300;
  font-size: 1.2rem;
  margin-top: 0;
  margin-bottom: 20px;
}

.footerf {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
  -moz-transition: opacity 0.5s ease-in-out;
  -webkit-transition: opacity 0.5s ease-in-out;
}
.active .footerf {
  opacity: 1;
}
.jw-icon-rewind {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/containers/Viewer.vue